import modalChangePassword from "@/components/OpenCall/changePassword/changePassword.vue";
import editIcon from "@/components/Icons/Edit/Edit.vue";
import iconPencilSquare from "@/components/Icons/PencilSquare/PencilSquare.vue";
import iconDownload from "@/components/Icons/Download/Download.vue";
import { async } from "q";
import alerts from "@/components/Alert/Alert.vue";
import modalConfirm from "@/components/Tools/Confirm/Confirm.vue";
import modalNewEdition from "@/components/Manager/newEdition/newEdition.vue";
import Download from "@/components/Icons/Download/Download.vue";
import apiUrl from "@/config/api";

import PdfViewer from "@/components/PdfViewer/PdfViewer.vue";

import * as XLSX from "xlsx/xlsx.mjs";

/* load 'fs' for readFile and writeFile support */
import * as fs from "fs";
XLSX.set_fs(fs);

/* load 'stream' for stream support */
import { Readable } from "stream";
XLSX.stream.set_readable(Readable);

/* load the codepage support library for extended support with older formats  */
import * as cpexcel from "xlsx/dist/cpexcel.full.mjs";
XLSX.set_cptable(cpexcel);

export default {
  name: "User",

  components: {
    modalChangePassword,
    editIcon,
    iconPencilSquare,
    iconDownload,
    alerts,
    modalConfirm,
    modalNewEdition,
    PdfViewer,
    Download,
  },

  data() {
    return {
      filter_order: "",
      filter_search: "",

      pdfRoute: "",

      actual_edition: "",
      loader: false,
      selected: [],
      selectAll: false,

      view_title: false,

      temp_obras: [],
      temp_portafolio: [],

      actual_order: null,

      menu: false,
      menuUser: 0,
      picked: false,
      modal_changePassword: false,
      modal_newEdition: false,

      alert_temp: {
        status: false,
        label: "",
        type: "",
      },

      modal_confirm: {
        status: false,
        title: "",
        text: "",
        question: "",
        callback: "",
      },

      /**     FILTERS     */
      tempSelect: "Selecciona...",
      typeSelectFlag: false,
      options: [
        { label: "Alfabéticamente", value: "alpha" },
        { label: "Mayor a menor promedio", value: "higher" },
        { label: "Menor a mayor promedio", value: "less" },
      ],

      search: "",

      actualKey: 0,
      score: 0,
      noScore: 5,
      managers: [],
      managers_list: false,
      opencall: {
        curriculum_vitae: "(...)",
        email: "(...)",
        finished: true,
        name: "(...)",
        obras: {},
        personal_data: {},
        portafolio: {},
        removed: false,
        status: "(...)",
        _id: "(...)",
        managers: [],
      },
      admin_controls: {
        status_opencall: false,
        status_evaluation: false,
        count_finalists: 0,
        count_winners: 0,
      },
      items: [
        {
          id: "1",
          artist: "a. de Carmen Reynoso Portillo",
          calification: "pendiente",
          "": { "2018-09-09": "{{asd}}<div></div>" },
        },
      ],
      items_finalist: [],
      columns: [
        { label: "Artista", name: "name" },
        { label: "Tu Calificación", name: "score" },
        { label: "Evaluación Administradores", name: "admin_average" },
        { label: "Acciones", name: "action" },
      ],
      columns_finalists: [
        { label: "Artista", name: "name" },
        { label: "Evaluación Consejo", name: "comun_average" },
        { label: "Acciones", name: "action" },
      ],
      baseUrl: "",
      baseUrl_tools: "",
      baseUrl_public: "",

      pages: 0,
      per_page: 100,
      current_page: 1,
    };
  },

  methods: {
    changePdfRoute(route) {
      this.pdfRoute = this.pdfRoute === "" ? route : "";
    },

    closeDropDown(status) {
      console.log(status);
    },

    migrate() {
      return;
      if (confirm("seguro de migrar")) {
        (async () => {
          await fetch(apiUrl + "migrate_opencalls", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              _id: this.$session.get("_id"),
            }),
          })
            .then(async (response) => {
              response = await response.json();
              // (response);
              if (response.status) {
                // this.items = response.opencalls;
              } else {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: response.msg,
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(response.msg);
              }
            })
            .catch((error) => {
              // (error);
            });
        })();
      }
    },

    migrate_FILES() {
      return;
      if (confirm("seguro de migrar los archivos?")) {
        (async () => {
          await fetch(apiUrl + "migrate_files_to_aws", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              _id: this.$session.get("_id"),
            }),
          })
            .then(async (response) => {
              response = await response.json();
              // (response);
              if (response.status) {
                // this.items = response.opencalls;
              } else {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: response.msg,
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(response.msg);
              }
            })
            .catch((error) => {
              // (error);
            });
        })();
      }
    },

    /** EDITIONS */
    /// Just Get Edition
    get_actual_edition() {
      (async () => {
        await fetch(apiUrl + "get_actual_edition", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then(async (response) => {
            response = await response.json();

            // some error && actual_edition do not exist
            if (!response.status && response.actual_edition === null) {
              //question, if you want create edition
              this.createEdition_confirm();
            } else {
              this.actual_edition = response.actual_edition.name;
              this.$session.set("actual_edition", response.actual_edition);
            }
          })
          .catch((error) => console.log("get_actual_edition" + error));
      })();
    },

    /// Create Edition
    createEdition_confirm() {
      this.modal_confirm = {
        title: "Ediciones",
        text: "No se encontro ninguna Edicion Activa.",
        question: "¿Te gustaria establecer una Edicion?",
        callback: "createEdition",
        status: false,
      };
      this.modal_confirm.status = true;
    },

    createEdition() {
      this.modal_newEdition = true;
    },

    export_data(type = null) {
      // validate if  already selected a user
      // if(false)
      if (this.selected.length < 1) {
        /** Alert */
        this.alert_temp = {
          status: true,
          type: "warning",
          label: "Selecciona algun usuario...",
        };
        setTimeout(() => {
          this.alert_temp.status = false;
        }, 3000);
        /** FIN Alerta */
      } else {
        if (type == "excel") {
          // exportar excel

          (async () => {
            await fetch(apiUrl + "export_data-excel", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                _id: this.$session.get("_id"),
                users: this.selected,
              }),
            })
              .then(async (response) => {
                response = await response.json();
                if (response.status) {
                  window.open("https://sandbox.api.salonacme.com/export/zipExport.zip");
                  // window.open("http://localhost:4001/export/zipExport.zip");
                } else {
                  /** Alert */
                  this.alert_temp = {
                    status: true,
                    type: "warning",
                    label: response.msg,
                  };
                  setTimeout(() => {
                    this.alert_temp.status = false;
                  }, 3000);
                  /** FIN Alerta */
                  // alert(response.msg);
                }
              })
              .catch((error) => console.log(error));
          })();
        } else {
          // exportar archivos

          (async () => {
            await fetch(apiUrl + "export_data-files", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                _id: this.$session.get("_id"),
                users: this.selected,
              }),
            })
              .then(async (response) => {
                response = await response.json();
                if (response.status) {
                  window.open("https://sandbox.api.salonacme.com/export/zipExport.zip");
                } else {
                  /** Alert */
                  this.alert_temp = {
                    status: true,
                    type: "warning",
                    label: response.msg,
                  };
                  setTimeout(() => {
                    this.alert_temp.status = false;
                  }, 3000);
                  /** FIN Alerta */
                  // alert(response.msg);
                }
              })
              .catch((error) => console.log(error));
          })();
        }
      }
    },

    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.items_finalist) {
          this.selected.push(this.items_finalist[i]._id);
        }
      }
    },

    obra_title(event) {
      // if text is more large to input with
      if (event.target.clientWidth < event.target.scrollWidth) {
        // document.getElementById("better-obra_title").setAttribute("style", " display: inline;");
        // document.getElementsByClassName("view_title").setAttribute("style", " display: inline;");
        this.view_title = true;
      }
    },

    obra_title_out() {
      // document.getElementById("better-obra_title").setAttribute("style", " display: none;");
      // document.getElementsByClassName("view_title").setAttribute("style", " display: none;");
      this.view_title = false;
    },

    async addImageProcess(src) {
      let img = new Image();
      img.src = src;
      return (img.onload = await (() => {
        // console.log(this.height);
        return this.height;
      }));
    },

    loadSprite(src, callback) {
      var sprite = new Image();
      sprite.onload = callback;
      sprite.src = src;
    },

    async checkImgs() {
      this.temp_portafolio = [];
      this.temp_obras = [];
      //// obras
      var keysToDelete = [];
      for (let i = 0; i < this.opencall.obras.length; i++) {
        var index = this.opencall.obras[i];

        // var url = "https://sandbox.api.salonacme.com/image/"+index.file;
        var url = this.$session.get("_aws_url_file") + index.file;

        if (index.file != "" && index.file.split(".")[1] !== "pdf") {
          var objImg = new Image();
          // var tmp = new Temp();
          // objImg.src = 'https://sandbox.api.salonacme.com/image/'+index.file;
          // var res = this.addImageProcess('https://sandbox.api.salonacme.com/image/'+index.file);
          // var res = this.addImageProcess('https://sandbox.api.salonacme.com/image/'+index.file)
          // var res = await objImg.onload();.

          // this.loadSprite('https://sandbox.api.salonacme.com/image/'+index.file, (e) => {
          this.loadSprite(
            this.$session.get("_aws_url_file") + index.file,
            (e) => {
              // code to be executed later
              // console.log('Regreso de cArgar-------------');
              // objImg = e.explicitOriginalTarget;
              // console.log(e);
              if (
                typeof e.explicitOriginalTarget === "undefined" &&
                typeof e.path !== "undefined"
              ) {
                objImg = e.path[0];
                if (objImg.height != 0 || objImg.width != 0) {
                  this.temp_obras.push(this.opencall.obras[i]);
                }
              } else if (typeof e.target !== "undefined") {
                objImg = e.target;
                if (objImg.height != 0 || objImg.width != 0) {
                  this.temp_obras.push(this.opencall.obras[i]);
                }
              } else {
                objImg = e.target;
                if (
                  objImg.naturalHeight != 0 ||
                  objImg.naturalWidth != 0 ||
                  objImg.height != 0 ||
                  objImg.width != 0
                ) {
                  this.temp_obras.push(this.opencall.obras[i]);
                }
              }
            }
          );
          // console.log(res)
          // console.log(res);

          // if(objImg.naturalHeight<1 && objImg.naturalWidth<1)
          // {
          //     keysToDelete.push(i);
          // }
          // console.log('obras', objImg.naturalHeight != 0 || objImg.naturalWidth != 0 ||
          // objImg.height != 0 || objImg.width != 0 );
          // console.log(objImg.height);
          // console.log(objImg.width);
          // console.log(objImg);
          // if(objImg.naturalHeight != 0 || objImg.naturalWidth != 0 ||
          //     objImg.height != 0 || objImg.width != 0)
          // {
          //     this.temp_obras.push(this.opencall.obras[i]);
          // }
          // objImg = null;
        } else if (index.file != "" && index.file.split(".")[1] === "pdf") {
          this.pdfExist_obras(url, i);
        } else {
          this.temp_obras.push(this.opencall.obras[i]);
        }
      }
      // for(var i = 0; i < keysToDelete.length; i++) {
      //     this.opencall.obras.splice(keysToDelete[i], 1);
      // }

      //// portafolio
      var keysToDelete = [];
      for (let i = 0; i < this.opencall.portafolio.length; i++) {
        var index = this.opencall.portafolio[i];

        // var url = "https://sandbox.api.salonacme.com/image/"+index.file;
        var url = this.$session.get("_aws_url_file") + index.file;

        if (index.file != "" && index.file.split(".")[1] !== "pdf") {
          var objImg_2 = new Image();
          // objImg_2.src = 'https://sandbox.api.salonacme.com/image/'+index.file;
          // if(objImg_2.naturalHeight<1 && objImg_2.naturalWidth<1)
          // {
          //     keysToDelete.push(i);
          // }
          // console.log('porta', objImg_2.naturalHeight != 0 || objImg_2.naturalWidth != 0 ||
          // objImg_2.height != 0 || objImg_2.width != 0 );
          // console.log(objImg_2.height);
          // console.log(objImg_2.width);
          // console.log(objImg_2);
          // if(objImg_2.naturalHeight != 0 || objImg_2.naturalWidth != 0 ||
          //     objImg_2.height != 0 || objImg_2.width != 0)
          // {
          //     this.temp_portafolio.push(this.opencall.portafolio[i]);
          // }
          // objImg_2 = null;
          // this.loadSprite('https://sandbox.api.salonacme.com/image/'+index.file, (e) => {
          this.loadSprite(
            this.$session.get("_aws_url_file") + index.file,
            (e) => {
              // code to be executed later
              // console.log('Regreso de cArgar-------------');
              objImg_2 = e.explicitOriginalTarget;

              if (
                typeof e.explicitOriginalTarget === "undefined" &&
                typeof e.path !== "undefined"
              ) {
                objImg_2 = e.path[0];
                if (objImg_2.height != 0 || objImg_2.width != 0) {
                  this.temp_portafolio.push(this.opencall.portafolio[i]);
                }
              } else if (typeof e.target !== "undefined") {
                objImg_2 = e.target;
                if (objImg_2.height != 0 || objImg_2.width != 0) {
                  this.temp_portafolio.push(this.opencall.portafolio[i]);
                }
              } else {
                objImg_2 = e.target;
                if (
                  objImg_2.naturalHeight != 0 ||
                  objImg_2.naturalWidth != 0 ||
                  objImg_2.height != 0 ||
                  objImg_2.width != 0
                ) {
                  this.temp_portafolio.push(this.opencall.portafolio[i]);
                }
              }
            }
          );
        } else if (index.file != "" && index.file.split(".")[1] === "pdf") {
          this.pdfExist_portafolio(url, i);
        } else {
          this.temp_portafolio.push(this.opencall.portafolio[i]);
        }
      }
      // for(var i = 0; i < keysToDelete.length; i++) {
      //     this.opencall.portafolio.splice(keysToDelete[i], 1);
      // }
      // console.log(this.opencall.obras);
      // console.log(this.temp_obras);
      // console.log(this.opencall.portafolio);
      // console.log(this.temp_portafolio);

      // vm.$forceUpdate();
      this.$forceUpdate();
    },

    pdfExist_obras(link, index) {
      var i = index;
      var url = link;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onprogress = (event) => {
        if (event.lengthComputable) {
          // console.log('isgood');
          this.temp_obras.push(this.opencall.obras[i]);
        } else {
          // this.opencall.obras.splice(index, 1);
        }
        xhr.abort();
      };
      xhr.send();
    },

    pdfExist_portafolio(link, index) {
      var i = index;
      var url = link;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.onprogress = (event) => {
        if (event.lengthComputable) {
          // console.log('isgood');
          this.temp_portafolio.push(this.opencall.portafolio[i]);
        } else {
          // this.opencall.portafolio.splice(index, 1);
        }
        xhr.abort();
      };
      xhr.send();
    },

    convertToMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
      try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : "") +
          i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : "")
        );
      } catch (e) {}
    },

    isCompleteUrl(value) {
      var url = value;
      return url.search("http") >= 0 ? url : "//" + url;
    },

    backOpenCall() {
      if (this.actualKey > 0) {
        this.actualKey--;
        this.actions(this.items[this.actualKey]._id);
        // return to personal data
        this.menuUser = 0;
      }
    },

    nextOpenCall() {
      if (this.actualKey < this.items.length - 1) {
        this.actualKey++;
        this.actions(this.items[this.actualKey]._id);
        // return to personal data
        this.menuUser = 0;
      }
    },

    actions(id, key = null, tempType = null) {
      // Load opencall data
      this.$root.opencall_view = false;
      if (key != null)
        // i think is to next and before
        this.actualKey = key;
      if (tempType == null) {
        var type = "admin";
      } else {
        var type = tempType;
      }
      (async () => {
        await fetch(apiUrl + "get_opencall", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            _id_opencall: id,
            type: type,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              this.score = response.score;
              this.opencall = response.opencall;
              this.managers = response.managers;

              this.checkImgs();
            } else {
              this.$root.opencall_view = true;
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */

              // alert(response.msg);
            }
          })
          .catch((error) => {
          });
      })();
    },

    actions_downloadPDF(id, key = null, tempType = null) {
      // Load opencall data
      // this.$root.opencall_view = false;
      if (key != null)
        // i think is to next and before
        this.actualKey = key;
      if (tempType == null) {
        var type = "admin";
      } else {
        var type = tempType;
      }
      (async () => {
        // await fetch(apiUrl + "get_opencall", {
        await fetch(apiUrl + "export_data-pdf", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            _id_opencall: id,
            type: type,
          }),
        })
          .then(async (response) => {
            response = await response.json();

            console.log(response);
            if (response.status == 200) {
              window.open(`https://sandbox.api.salonacme.com/export/${response.file}`);
              // this.score = response.score;
              // this.opencall = response.opencall;
              // this.managers = response.managers;

              // this.checkImgs();
            } else {
              // this.$root.opencall_view = true;
              // /** Alert */
              // this.alert_temp = {
              //   status: true,
              //   type: "warning",
              //   label: response.msg,
              // };
              // setTimeout(() => {
              //   this.alert_temp.status = false;
              // }, 3000);
              /** FIN Alerta */
              // alert(response.msg);
            }
          })
          .catch((error) => {
          });
      })();
    },

    get_controls() {
      (async () => {
        await fetch(apiUrl + "get_control", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              this.admin_controls = response.controls;
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */
              // alert(response.msg);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      })();
    },

    async get_pages(order = null, search = null) {
      //'https://sandbox.api.salonacme.com'
      await fetch(apiUrl + "get_pages_opencalls_admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          _id: this.$session.get("_id"),
          order: order,
          search: search,
          per_page: this.per_page,
        }),
      })
        .then(async (response) => {
          response = await response.json();

          this.pages = response.pages;
        })
        .catch((error) => {});
    },

    prevPage() {
      if (this.current_page != 1) {
        this.current_page = this.current_page - 1;

        this.get_opencalls(this.filter_order, this.filter_search);
      }
    },

    selectPage(page) {
      this.current_page = page;

      this.get_opencalls(this.filter_order, this.filter_search);
    },

    nextPage() {
      if (this.current_page != this.pages) {
        this.current_page = this.current_page + 1;

        this.get_opencalls(this.filter_order, this.filter_search);
      }
    },

    //vvvvvvvvvvvvvvv
    get_opencalls(order = null, search = null) {
      /// Load all Opencalls
      this.loader = true;
      this.filter_order = order;
      this.filter_search = search;

      (async () => {
        //'http://localhost:4001/manager/get_opencalls_admin'
        //apiUrl + 'get_opencalls_admin'
        await fetch(apiUrl + "get_opencalls_admin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            order: order,
            search: search,
            per_page: this.per_page,
            page: this.current_page,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              this.items = response.opencalls;
              for (let index = 0; index < this.items.length; index++) {
                // if(typeof this.items[index].admin_average == 'undefined'){
                //     this.items[index].admin_average = '-';
                //     this.items[index].forOrder = -1;
                // }else
                // if(!this.items[index].managers){
                //     this.items[index].admin_average = 'pendiente';
                //     this.items[index].forOrder = 0;
                // }else
                // console.log(this.items[index].admin_average);
                if (typeof this.items[index].admin_average !== "undefined") {
                  // var temp = this.items[index].admin_average.$numberDecimal;
                  var temp = this.items[index].admin_average;
                  this.items[index].forOrder = this.items[index].score;

                  if (this.items[index].admin_average !== null)
                    this.items[index].admin_average =
                      parseFloat(temp).toFixed(2);
                  else this.items[index].admin_average = "-";
                }
              }
              ///

              // this.items = response.opencalls;
              // for (let index = 0; index < this.items.length; index++) {
              //     if(typeof this.items[index].score == 'undefined' || this.items[index].score < 1){
              //         this.items[index].score = false;
              //     }
              // }

              /////

              if (order == "higher" && search == null)
                this.items.sort(function (a, b) {
                  if (a.admin_average > b.admin_average) {
                    return -1;
                  }
                  if (a.admin_average < b.admin_average) {
                    return 1;
                  }
                  // a must be equal to b
                  return 0;
                });
              if (order == "less" && search == null)
                this.items.sort(function (a, b) {
                  if (a.admin_average > b.admin_average) {
                    return 1;
                  }
                  if (a.admin_average < b.admin_average) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                });

              /////
              // if(order == 'higher' && search == null)
              // this.items.sort(function (a, b) {
              //     if (a.forOrder > b.forOrder) {
              //       return -1;
              //     }
              //     if (a.forOrder < b.forOrder) {
              //       return 1;
              //     }
              //     // a must be equal to b
              //     return 0;
              //   });
              // if(order == 'less' && search == null)
              // this.items.sort(function (a, b) {
              //     if (a.forOrder > b.forOrder) {
              //       return 1;
              //     }
              //     if (a.forOrder < b.forOrder) {
              //       return -1;
              //     }
              //     // a must be equal to b
              //     return 0;
              // });
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */
              // alert(response.msg);
            }
          })
          .catch((error) => {
            // console.log(error);
          });
        this.loader = false;
      })();
    },

    get_opencalls_finalist(order = null, search = null) {
      (async () => {
        await fetch(apiUrl + "get_opencalls_admin_finalist", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            order: order,
            search: search,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              // this.items_finalist = response.opencalls;
              // for (let index = 0; index < this.items.length; index++) {
              //     if(typeof this.items[index].admin_average == 'undefined'){
              //         this.items[index].admin_average = '-';
              //     }else
              //     if(!this.items[index].managers){
              //         this.items[index].admin_average = 'pendiente';
              //     }else
              //     if(typeof this.items[index].admin_average !== 'undefined'){
              //         var temp = this.items[index].admin_average.$numberDecimal;
              //         this.items[index].admin_average = parseFloat(temp).toFixed(2);
              //     }
              // }

              this.items_finalist = response.opencalls;

              // for (let index = 0; index < this.items_finalist.length; index++) {
              //     if(this.admin_controls.status_evaluation){
              //         if(typeof this.items_finalist[index].comun_average == 'undefined'){
              //             this.items_finalist[index].comun_average = '-';
              //             this.items_finalist[index].forOrder = -1;
              //         }else
              //         if(!this.items_finalist[index].managers){
              //             this.items_finalist[index].comun_average = 'pendiente';
              //             this.items_finalist[index].forOrder = 0;
              //         }else
              //         if(typeof this.items_finalist[index].comun_average !== 'undefined'){
              //             var temp = this.items_finalist[index].comun_average.$numberDecimal;
              //             this.items_finalist[index].comun_average = parseFloat(temp).toFixed(2);
              //             this.items_finalist[index].forOrder = parseFloat(temp).toFixed(2);
              //         }
              //     }else{
              //         var temp = this.items_finalist[index].comun_average.$numberDecimal;
              //         this.items_finalist[index].comun_average = parseFloat(temp).toFixed(2);
              //         this.items_finalist[index].forOrder = parseFloat(temp).toFixed(2);
              //     }
              // }

              if (order == "higher" && search == null)
                this.items_finalist.sort(function (a, b) {
                  if (a.comun_average > b.comun_average) {
                    return -1;
                  }
                  if (a.comun_average < b.comun_average) {
                    return 1;
                  }
                  // a must be equal to b
                  return 0;
                });
              if (order == "less" && search == null)
                this.items_finalist.sort(function (a, b) {
                  if (a.comun_average > b.comun_average) {
                    return 1;
                  }
                  if (a.comun_average < b.comun_average) {
                    return -1;
                  }
                  // a must be equal to b
                  return 0;
                });
            } else {
              // alert(response.msg);
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    exportExcel: function () {
      let dataExport = JSON.parse(JSON.stringify(this.items_finalist));
      for (let index = 0; index < dataExport.length; index++) {
        delete dataExport[index]._id;
        delete dataExport[index].personal_data;
        delete dataExport[index].editions;
        delete dataExport[index].insensitive;
        dataExport[index].comun_average = parseFloat(
          dataExport[index].comun_average
        ).toFixed(2);
      }
      let data = XLSX.utils.json_to_sheet(dataExport);
      const workbook = XLSX.utils.book_new();
      const filename = "devschile-admins";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    exportExcelNoFinalist: function () {
      // Esta opcion necesi atraer a todos los finalistas y eso se obtiene
      // desde get_opencalls enviando null a per_page: null, page: null
      // y habilitar el boton de front y aqui comentar el return de abajo
      return;
      let dataExport = JSON.parse(JSON.stringify(this.items));

      for (let index = 0; index < dataExport.length; index++) {
        delete dataExport[index]._id;
        delete dataExport[index].admin_average;
        delete dataExport[index].editions;
        delete dataExport[index].forOrder;
        delete dataExport[index].personal_data;
        delete dataExport[index].score;
      }

      let data = XLSX.utils.json_to_sheet(dataExport);
      const workbook = XLSX.utils.book_new();
      const filename = "nofinalistlist";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },

    callOrder(order) {
      this.actual_order = order;
      this.get_opencalls(order);
    },

    callOrder_finalist(order) {
      this.actual_order = order;
      this.get_opencalls_finalist(order);
    },

    searchF() {
      this.get_opencalls(null, this.search);
    },

    searchF_finalist() {
      this.get_opencalls_finalist(null, this.search);
    },

    changeScore(score) {
      (async () => {
        await fetch(apiUrl + "set_score", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            _id_opencall: this.opencall._id,
            score: score,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              this.actions(this.opencall._id);
            } else {
              alert(response.msg);
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    changeStatusOpencall_confirm() {
      this.modal_confirm = {
        title: "Convocatorias",
        text: "Confirma tu accion.",
        question: "¿Cambiar el estado de las Convocatorias?",
        callback: "changeStatusOpencall",
        status: false,
      };
      this.modal_confirm.status = true;
    },

    changeStatusOpencall() {
      var status_opencall = this.admin_controls.status_opencall;

      (async () => {
        await fetch(apiUrl + "set_control", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            opencall: status_opencall,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              if (response._status) {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "success",
                  label: "Convocatoria Activada",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */

                // alert(' Convocatoria Activada ');
              } else {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: "Convocatoria Desactivada",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */

                // alert(' Convocatoria Desactivada ');
              }
              setTimeout(() => {
                this.get_controls();
              }, 100);
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */

              // alert(response.msg);
              this.admin_controls.status_opencall =
                !this.admin_controls.status_opencall;
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    changeStatusEvaluation_confirm() {
      this.modal_confirm = {
        title: "Evaluaciones",
        text: "Confirma tu accion.",
        question: "¿Cambiar el estado de las Evaluaciones?",
        callback: "changeStatusEvaluation",
        status: false,
      };
      this.modal_confirm.status = true;
    },

    changeStatusEvaluation() {
      var status_evaluation = this.admin_controls.status_evaluation;

      (async () => {
        await fetch(apiUrl + "set_control", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            evaluation: status_evaluation,
            with_button: false,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              ///// No llega  response._status, algo desde la api falta
              if (typeof response._status === "undefined" || response._status) {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "success",
                  label: "Evaluacion Activada",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(' Evaluacion Activada ');
              } else {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: "Evaluacion Desactivada",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(' Evaluacion Desactivada ');
              }
              this.get_opencalls_finalist();
              setTimeout(() => {
                this.get_controls();
              }, 100);
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */

              // alert(response.msg);
              this.admin_controls.status_evaluation =
                !this.admin_controls.status_evaluation;
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    changeStatusEvaluation_with_button() {
      var status_evaluation = this.admin_controls.status_evaluation;

      (async () => {
        await fetch(apiUrl + "set_control", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            evaluation: status_evaluation,
            with_button: true,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              ///// No llega  response._status, algo desde la api falta
              if (typeof response._status === "undefined") {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "success",
                  label: "Finalistas Generados",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(' Evaluacion Activada ');
              } else {
                /** Alert */
                this.alert_temp = {
                  status: true,
                  type: "warning",
                  label: "Algun error, no puedes generar finalistas",
                };
                setTimeout(() => {
                  this.alert_temp.status = false;
                }, 3000);
                /** FIN Alerta */
                // alert(' Evaluacion Desactivada ');
              }
              this.get_opencalls_finalist();
              setTimeout(() => {
                this.get_controls();
              }, 100);
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */

              // alert(response.msg);
              this.admin_controls.status_evaluation =
                !this.admin_controls.status_evaluation;
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    changeFinalistsNumber() {
      (async () => {
        var finalistsNumber = parseInt(this.admin_controls.count_finalists);

        if (finalistsNumber < 1 || !Number.isInteger(finalistsNumber)) {
          return;
        }

        await fetch(apiUrl + "set_control", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            _id: this.$session.get("_id"),
            count_finalists: finalistsNumber,
          }),
        })
          .then(async (response) => {
            response = await response.json();
            if (response.status) {
              setTimeout(() => {
                this.get_controls();
                this.changeStatusEvaluation_with_button();
              }, 100);
            } else {
              /** Alert */
              this.alert_temp = {
                status: true,
                type: "warning",
                label: response.msg,
              };
              setTimeout(() => {
                this.alert_temp.status = false;
              }, 3000);
              /** FIN Alerta */

              // alert(response.msg);
            }
          })
          .catch((error) => console.log(error));
      })();
    },

    confirms(opc) {
      switch (opc) {
        case "changeStatusOpencall":
          if (this.modal_confirm.response) {
            this.changeStatusOpencall();
          } else {
            setTimeout(() => {
              this.admin_controls.status_opencall =
                !this.admin_controls.status_opencall;
            }, 100);
          }
          break;
        case "changeStatusEvaluation":
          if (this.modal_confirm.response) {
            this.changeStatusEvaluation();
          } else {
            setTimeout(() => {
              this.admin_controls.status_evaluation =
                !this.admin_controls.status_evaluation;
            }, 100);
          }
          break;

        case "createEdition":
          if (this.modal_confirm.response) {
            this.createEdition();
          } else {
            setTimeout(() => {}, 100);
          }
          break;

        default:
          break;
      }
    },

    downloadCV() {
      let pdf_url =
        this.$session.get("_aws_url_file") +
        this.opencall.curriculum_vitae_doc_file;
      console.log("descargarArchivo");
      // console.log((this.$session.get('_aws_url_file') + this.opencall.curriculum_vitae_doc_file));
      // let enlaceDescarga = document.createElement('a');
      // enlaceDescarga.href = pdfurl; // Reemplaza 'URL_DEL_ARCHIVO' con la URL de tu archivo
      // enlaceDescarga.download = 'cv.pdf'; // Puedes establecer el nombre del archivo que se descargará
      // document.body.appendChild(enlaceDescarga);
      // enlaceDescarga.click();
      // document.body.removeChild(enlaceDescarga);

      let x = new XMLHttpRequest();
      x.open("GET", pdf_url, true);
      x.responseType = "blob";
      x.onload = function (e) {
        saveAs(x.response, "cv.pdf", "application/pdf");
      };
      x.send();
    },
  },

  watch: {
    score: function (newQuestion) {
      this.noScore = 5 - this.score;
    },
    "$root.opencall_view": function (newQuestion) {
      if (this.$root.opencall_view) this.get_opencalls(this.actual_order);
    },
  },

  mounted() {
    this.get_actual_edition();
    this.get_controls();
    this.get_pages();
    this.get_opencalls();
    this.get_opencalls_finalist();

    // console.log(this.$parent.baseUrl);
    this.baseUrl = this.$parent.baseUrl;
    this.baseUrl_public = this.$parent.baseUrl_public;
    this.baseUrl_tools = this.$parent.baseUrl_tools;
  },
};
